import { render, staticRenderFns } from "./ConsultationInSharedRoom.vue?vue&type=template&id=29cc3265&scoped=true&"
import script from "./ConsultationInSharedRoom.vue?vue&type=script&lang=js&"
export * from "./ConsultationInSharedRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cc3265",
  null
  
)

export default component.exports